document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nutrients-showcase-slider').forEach((slider) => {
    const selectors = slider.querySelectorAll('.nutrients-showcase-slider-selector');
    const slides = slider.querySelectorAll('.nutrients-showcase-slide');
    const holder = slider.querySelector('.nutrients-showcase-slider-holder');

    if (!selectors.length) {
      return;
    }

    const updateInert = () => {
      const activeIndex = Array.prototype.findIndex.call(selectors, (selector) => selector.checked);
      slides.forEach((slide, index) => {
        slide.toggleAttribute('inert', index !== activeIndex);
      });
    };

    const changeSlide = (direction) => {
      const currentIndex = Array.prototype.findIndex.call(selectors, (selector) => selector.checked);
      const newIndex = (currentIndex + direction + selectors.length) % selectors.length;
      selectors[newIndex].click();
    };

    slider.querySelectorAll('[data-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        changeSlide(button.dataset.direction === 'prev' ? -1 : 1);
      });
    });

    slider.addEventListener('change', (e) => {
      if (e.target.classList.contains('nutrients-showcase-slider-selector')) {
        updateInert();
      }
    });

    if (holder) {
      let touchstartX = 0;
      const threshold = 40;

      holder.addEventListener('touchstart', (e) => {
        touchstartX = e.changedTouches[0].screenX;
      });

      holder.addEventListener('touchend', (e) => {
        const touchendX = e.changedTouches[0].screenX;
        if (touchendX < touchstartX - threshold) changeSlide(+1);
        if (touchendX > touchstartX + threshold) changeSlide(-1);
      });
    }

    updateInert();
  });
});
